module.exports = __webpack_public_path__ + "images/emoji/white_flower.3f5052fc97972e239a0d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_flower.png
// module id = gTcN
// module chunks = 14